<template>
    <Article>
        <template #header>
            <h2>Websites/Books/Videos</h2>
        </template>
        <template #content>
            <div id="post-68" class="clearfix post-68 page type-page status-publish hentry">
                <p style="text-align:center">
                    <em>
                        Note: We have made an effort to list everything we have found relevant to
                        the topic of Merrill's Marauders. Resources listed here in
                        <span style="color:red">RED</span>
                        appear to no longer be available.
                    </em>
                </p>
                <p><strong>WEBSITES</strong></p>
                <p>
                    <strong>
                        <a
                            href="http://www.danielnovak.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Daniel Novak website
                        </a>
                        .
                    </strong>
                    WWII Army still and motion photographer assigned to the 164
                    <sup>th</sup>
                    Signal Photographic Co. who documented the war in Burma. Novak
                    <span class="style_1">
                        served with the 164th Signal Photographic Co. in the CBI Theater of War,
                        mostly in Burma as a motion picture photographer.
                        <br />
                    </span>
                </p>
                <p>
                    <strong>
                        <a
                            href="http://www.cbi-history.com/part_vi_mars2.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            MARS Task Force
                        </a>
                        .
                    </strong>
                    A brief history of the MARS Task Force which relieved the exhausted Marauders.
                    MARS was responsible for pushing the Japanese out of Burma and reaching the
                    final objective of opening up the land route into China.
                </p>
                <p>
                    <strong>
                        <a href="http://www.75thrra.com" target="_blank" rel="noopener noreferrer">
                            75
                            <sup>th</sup>
                            Ranger Regiment Association
                        </a>
                        .
                    </strong>
                    The 7
                    <sup>th</sup>
                    Airborne Ranger Infantry Regiment bears the colors and draws their lineage from
                    the 5307 Composite Unit (Provisional), i.e., Merrill's Marauders. Membership to
                    this Ranger organization is FREE to all Merrill's Marauders.
                </p>
                <p>
                    <strong>
                        <a
                            href="https://facebook.com/groups/crea8ivjr/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Merrill's Marauders Proud Descendants Facebook Page
                        </a>
                        .
                    </strong>
                    This is the
                    <em>official</em>
                    Facebook page of the "Proud Descendants." We are offspring of the Merrill's
                    Marauders Association and welcome all.
                </p>
                <p>
                    <strong>
                        <a
                            href="https://www.facebook.com/groups/71823308791/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Merrill's Marauders Proud Descendants Facebook Page
                        </a>
                        .
                    </strong>
                    This page is a separate but very welcome group of individuals who are also
                    descendants of the Marauders. At the time the MMPD Association started our
                    Facebook page, we didn't realize there was one up and running already.
                    Definitely check out this site and join!
                </p>
                <p>
                    <strong>
                        <a
                            href="http://www.nationalveteransnetwork.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            National Veterans Network
                        </a>
                        :
                    </strong>
                    The National Veterans Network is a coalition that enlightens the public about
                    the legacy of Japanese American World War II soldiers.
                </p>
                <p>
                    <span style="color:red">
                        <strong>
                            Merrill's Marauders: Combined Operations in Northern Burma in 1944
                        </strong>
                        by Gary J. Bjorge, printed courtesy of the US Army Center of Military
                        History, Washington, DC.
                    </span>
                </p>
                <p>
                    <strong>
                        <a
                            href="http://cgsc.cdmhost.com/u?/p4013coll2,2272"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Galahad Redux: An Assessment of the Disintegration of the Merrill's
                            Marauders
                        </a>
                        ,&nbsp;
                    </strong>
                    by John B. Gaither, US Army Command and General Staff College, Combined Arms
                    Research Library (CARL). A critical discussion of the management of the Burman
                    campaign and the decisions of the commanders with respect to the welfare and
                    morale of the fighting troops. Very interesting reading.
                </p>
                <p>
                    <strong>
                        <a
                            href="http://www.archives.gov/veterans/military-service-records/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            eVetRecs, The National Archives
                        </a>
                        .
                    </strong>
                    Online military personnel records request system. Create a customized order form
                    to request information on your, or your relative's military records.
                </p>
                <p>
                    <strong>
                        <a
                            href="http://www.ranger.org/page-578463"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            National Ranger Memorial Foundation, Ranger Hall of Fame
                        </a>
                        .
                    </strong>
                    &nbsp; 25 Merrill's Marauders have been inducted into the US Army Ranger
                    Association Ranger Hall of Fame.
                </p>
                <p style="text-align:left">
                    <strong>
                        <a
                            href="http://www.lib.utexas.edu/maps/ams/burma/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Topographic Mapping of Burma
                        </a>
                        .
                    </strong>
                    University of Texas at Austin, US Army Map Service, 1955.
                </p>
                <p style="text-align:center">
                    <img
                        loading="lazy"
                        class="aligncenter size-full wp-image-375"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/yellow-star.png?alt=media"
                        alt="yellow-star"
                        width="44"
                        height="42"
                    />
                </p>

                <p>
                    <strong>
                        BOOKS
                        <br />
                    </strong>
                    <strong><br /></strong>
                </p>
                <p>
                    <a href="https://www.amazon.com/General-Sam-Drew-Prehmus/dp/1484981960">
                        <strong>General Sam:</strong>
                    </a>
                    A Biography of Lieutenant General Samuel Vaughan Wilson.
                </p>
                <p>
                    <strong>
                        <a
                            href="http://www.history.army.mil/books/wwii/marauders/marauders-fw.htm"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Merrill's Marauders, Center of Military History
                        </a>
                        .
                    </strong>
                    US Army. (A reprint and web accessible document of Merrill's Marauders
                    (February-May 1944) American Forces in Action Series, War Department Historical
                    Division.)
                </p>
                <p>
                    <strong>Spearhead: A Complete History of Merrill's Marauder Rangers,</strong>
                    by James E.T. Hopkins and John M. Jones. Galahad Press (1999), Paperback, 772
                    pages, ISBN 0801864046
                    <em>(Original Version)</em>
                </p>
                <p style="text-align: center;">
                    <a
                        href="http://www.amazon.com/Spearhead-Complete-History-Merrills-Marauder/dp/0989839400/ref=sr_1_1?ie=UTF8&amp;qid=1428175697&amp;sr=8-1&amp;keywords=spearhead+marauder+book"
                    >
                        <img
                            loading="lazy"
                            class="aligncenter wp-image-304"
                            style="border: 1px solid #000000;"
                            src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/spearhead-cover.jpg?alt=media"
                            alt="spearhead-cover"
                            width="150"
                            height="225"
                            srcset="
                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/spearhead-cover.jpg?alt=media 200w,
                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/spearhead-cover.jpg?alt=media 267w,
                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/spearhead-cover.jpg?alt=media 133w,
                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/spearhead-cover.jpg?alt=media 288w
                            "
                            sizes="(max-width: 150px) 100vw, 150px"
                        />
                    </a>

                    <br />
                    <br />
                    <strong>"A Complete History of Merrill's Marauders Rangers"</strong>
                    By Dr. James E. T. Hopkins &amp; John M. Jones
                    <br />
                    Available at
                    <a
                        href="http://www.amazon.com/Spearhead-Complete-History-Merrills-Marauder/dp/0989839400/ref=sr_1_1?ie=UTF8&amp;qid=1428176953&amp;sr=8-1&amp;keywords=spearhead+marauder+book"
                        target="_blank"
                    >
                        Amazon.com
                        <br />
                        <em>
                            The MERRILL'S MARAUDERS ASSOCIATION
                            <br />
                            —
                        </em>
                        740 pages, 28 maps, 52 photos, index. —
                    </a>
                </p>
                <p>
                    <strong>
                        Jungle Stories: The Life of Delmar Strunk — From the Fields of South Dakota
                        to the Jungles of Burma,
                    </strong>
                    by Randall M. Dewitt. XLIBRIS (2015), Hardcover or Paperback, 324 pages, ISBN
                    978-1503548084. Kindle version also available.
                </p>
                <p>
                    <span style="text-decoration:underline;color:#339">
                        <a href="http://www.merrillsmarauderspd.org/the-fightin-preacher/">
                            <strong>The Fightin' Preacher</strong>
                        </a>
                        <strong>,</strong>
                    </span>
                    by Col. Logan E. Weston. Vision Press (1992), Paperback, 304 pages, ISBN
                    978-15709011-1-9.
                </p>
                <p>
                    <a href="http://www.merrillsmarauderspd.org/the-fightin-preacher/">
                        <span style="text-decoration:underline">
                            <strong>
                                <span style="color:#339;text-decoration:underline">
                                    The Fightin' Preacher
                                </span>
                            </strong>
                        </span>
                    </a>
                    , (reprinted) by Col. Logan E. Weston. Vision Press (2016), Paperback, 312
                    pages, ISBN 978 – 0–692-73438 -4.
                </p>
                <p style="text-align:center">
                    <span style="color:#396">
                        <strong><em>Now Available!</em></strong>
                    </span>
                </p>
                <h6 style="text-align:center">
                    <span style="color:#396">
                        <em>Cost $20</em>
                        (includes S/H).&nbsp; Bulk rate discounts are available.
                    </span>
                </h6>
                <p style="text-align:center">
                    <span style="color:#396">
                        <em>
                            (Part of the proceeds from each book sold through Merrill's Marauders
                            Proud Descendants will be donated to the association.)
                        </em>
                    </span>
                    <br />
                    <span style="color:#396">
                        Send check to: Sherry Cowling, 77 Via Larga Vista, Bonsall, CA 92003;
                        <a style="color:#396" href="mailto:MLcowling@duck.com">
                            MLcowling@duck.com
                        </a>
                    </span>
                </p>
                <p style="text-align:center">
                    <span style="color:#396">Please reference this website when you order!</span>
                </p>
                <div></div>
                <p>
                    <strong>
                        Hell on Land, Disaster at Sea, the Story of Merrill's Marauders and the
                        Sinking of the Rhona,
                    </strong>
                    by Fred E. Randle, William W. Hughes-Turner (2003). Hardcover, 143 pages, ISBN
                    1563117762
                </p>
                <p>
                    <strong>The Marauders,</strong>
                    by Charlton Ogburn, Jr. Penguin Paperback (2002). Reprint of 1956 hardcover, 307
                    pages. ISBN 978-15856723-4-9
                </p>
                <p>
                    <strong>
                        The Burma Road, the Epic Story of the China-Burma-India Theater in World War
                        II,
                    </strong>
                    by Donovan Webster, Farrar, Straus and Giroux (2003). Hardcover, ISBN 0374117403
                </p>
                <p>
                    <strong>Stillwell and the American Experience in China, 1911-45,</strong>
                    Barbara W. Tuchman. MacMillan Company (1970). Hardcover, ISBN 978-15684960-4-7
                </p>
                <p>
                    <strong>The Stilwell Papers,</strong>
                    Joseph W. Stilwell and Theodore White. W. Sloane Associates (1948). 357 pages.
                    ISBN 978-03068042-8-1
                </p>
                <p style="text-align:center">
                    <img
                        loading="lazy"
                        class="aligncenter size-full wp-image-375"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/yellow-star.png?alt=media"
                        alt="yellow-star"
                        width="44"
                        height="42"
                    />
                </p>

                <p><strong>MOVIES/VIDEO</strong></p>
                <p>
                    <span style="color:#000">
                        <strong>Dangerous Missions: Merrill's Marauders, 2002.</strong>
                        The History Channel, 50 minutes.
                        <br />
                    </span>
                </p>
                <p>
                    <strong>Merrill's Marauders,</strong>
                    Warner Brothers, 1962. Starring Jeff Chandler, Ty Hardin and Peter Brown.
                    Directed by Samuel Fuller.
                </p>
                <p>
                    <strong>
                        <a
                            href="https://archive.org/details/gov.archives.arc.603003"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Merrill's Marauders, National Archives and Records Administration
                        </a>
                        .
                    </strong>
                    &nbsp; This film covers the secret campaign, under General Frank D. Merrill, to
                    reopen the Burma Road behind enemy lines during World War II. The film was
                    photographed and produced by David L. Quaid.&nbsp; Black and white, 1944.
                    Length, 25:43.&nbsp; Made possible by a donation from Jim Schrempp.
                </p>
                <p>
                    <a
                        href="https://www.youtube.com/watch?v=GnFbDKM0yH0&amp;feature=youtu.be"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <strong>The Big Picture: The Joseph Warren Stilwell Story.</strong>
                    </a>
                    Created by Department of Defense. Department of the Army. Office of the Deputy
                    Chief of Staff for Operations. U.S. Army Audiovisual Center. Length, 2:09. (ca.
                    1974 – 05/15/1984 )
                </p>
                <p>
                    <strong>
                        <a href="http://honordoc.com" target="_blank" rel="noopener noreferrer">
                            Honor &amp; Sacrifice
                        </a>
                        .
                    </strong>
                    The historical documentary "Honor &amp; Sacrifice" is the story of Roy
                    Matsumoto, a member of Merill's Marauders, member of the Ranger Hall of fame in
                    1993 for his service during World War II; a Distinguished Member of the 75th
                    Ranger Regiment the following year; and inducted into the Military Intelligence
                    Corps Hall of Fame in 1997. He was also awarded the Congressional Gold Medal in
                    2011 with other WWII veterans of Japanese heritage. The film explores,
                    celebrates and tells the story of young Japanese American soldiers and their
                    families during the war. These men and women, known as Nisei, served with great
                    distinction the country they loved, the United States of America. Produced by
                    Stourwater Pictures. Video available for purchase.
                </p>
                <p style="text-align:center">
                    <img
                        loading="lazy"
                        class="aligncenter size-full wp-image-375"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/yellow-star.png?alt=media"
                        alt="yellow-star"
                        width="44"
                        height="42"
                    />
                </p>

                <p><strong>NEWS ARTICLES</strong></p>
                <p>
                    <strong>
                        <a
                            href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Yank-Article-Jun-16-1944.pdf?alt=media"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Yank Magazine, June 1944. "Merrill's Makeshift Artillery."
                        </a>
                    </strong>
                </p>
                <p>
                    <strong>
                        <a
                            href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Yank-Article-Notes-From-Burma-Diary.pdf?alt=media"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Yank Magazine, Date Unknown. "Notes from a Burma Diary."
                        </a>
                    </strong>
                    Thanks to L. R. Burchett.
                </p>
                <p style="text-align:center">
                    <img
                        loading="lazy"
                        class="aligncenter size-full wp-image-375"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/yellow-star.png?alt=media"
                        alt="yellow-star"
                        width="44"
                        height="42"
                    />
                </p>
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'WebsitesBooksVideos',
    components: { Article }
});
</script>
